export enum EvalAnswer {
    RECOMMENDED = 'RECOMMENDED',
    NOT_A_FIT = 'NOT_A_FIT',
    DONT_KNOW_THEM = 'DONT_KNOW_THEM',
}

export type CandidateEvaluationDto = {
    personId: string
    evalAnswer: EvalAnswer
    evalComment?: string
}

export type GetCandidateEvaluationsRes = {
    evaluations: CandidateEvaluationDto[]
}
